import styled from 'styled-components'

export const Div = styled.div`
  display: flex;
  justify-content: space-between;
`
